<nz-list
  nzItemLayout="vertical"
  *ngIf="validations$ | async as validations"
  [nzDataSource]="validations"
  [nzRenderItem]="validationItemRef"
>
  <ng-template #validationItemRef let-item>
    <em-validation-item [validationItem]="item"></em-validation-item>
  </ng-template>
</nz-list>
